import { MergeEntityName } from "@/api-schema-enums";
import { BrandCombobox } from "./brand-combobox";
import { ModelFamilyCombobox } from "./model-family-combobox";
import { ModelGenerationCombobox } from "./model-generation-combobox";

interface MergeTargetComboboxProps {
  entity: MergeEntityName;
  value: string;
  onChange: (uuid: string, label: string, logoUrl?: string) => void;
  excludeUuid?: string;
}

export const MergeTargetCombobox = ({ entity, ...props }: MergeTargetComboboxProps) => {
  switch (entity) {
    case MergeEntityName.Brand:
      return <BrandCombobox {...props} />;
    case MergeEntityName.ModelFamily:
      return <ModelFamilyCombobox {...props} />;
    case MergeEntityName.ModelGeneration:
      return <ModelGenerationCombobox {...props} />;
    default:
      return null;
  }
};
